import { ApolloError } from "@apollo/client";

import { ContextWorkbenchChangesetFragment } from "../../queries/useInitContextWorkbenchChangeset.generated";
import { OrgGuideFileWithBaseVersionFragment } from "../../queries/useInitContextWorkbenchPublishBaseFiles.generated";
import { ContextWorkbenchState } from "../contextWorkbenchState";
import { ContextWorkbenchSelectorOptions } from "../selectors/options";
import { contextWorkbenchPublishSelectors } from "../selectors/publishSelectors";

export type InitPublishBaseFilesPayload = {
  data: readonly OrgGuideFileWithBaseVersionFragment[] | null | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  options: ContextWorkbenchSelectorOptions;
};

export type InitPublishChangesetPayload = {
  data: ContextWorkbenchChangesetFragment | null | undefined;
  loading: boolean;
  error: ApolloError | undefined;
};

export function initPublishChangeset(
  state: ContextWorkbenchState,
  payload: InitPublishChangesetPayload,
): void {
  const { data, error, loading } = payload;
  state.publish.changeset = {
    loading: loading,
    error: error,
    value: data ?? undefined,
    loadId: data?.id ?? state.publish.changeset.loadId,
  };
}

export function initPublishBaseFiles(
  state: ContextWorkbenchState,
  payload: InitPublishBaseFilesPayload,
): void {
  const { data, error, loading } = payload;
  state.publish.baseFiles = {
    loading: loading,
    error: error,
    value: data ?? undefined,
  };

  // auto-select the first changed file
  if (data && !state.publish.selectedFileId) {
    state.publish.selectedFileId =
      contextWorkbenchPublishSelectors.selectFirstVisibleFile(
        { contextWorkbench: state },
        payload.options,
      );
  }
}
